/**
 * ELECTRONIC_ARCHETYPE
 *
 * Statistical profile for EDM, Synthwave, Techno, and Ambient.
 * Focuses on loop-based structures, precise rhythm, and specific frequency curves.
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const ELECTRONIC_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Static or Slow
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // 1 Chord per 4 bars
        tolerance: 2.0,
        weight: 0.15
    },

    // Voice Distribution: Smiley Face (Sub Bass + High Hats)
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40,
        mid: 0.20,
        high: 0.40,
        tolerance: 0.15,
        tuttiThreshold: 0.9,
        weight: 0.25
    },

    // Dynamic Range: Compressed (Loud) or Build-Drop
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.05,
        targetVariance: 0.2, // Builds create variance
        dynamicShape: 'linear', // Sweeps
        weight: 0.2
    },

    // Interval Entropy: Repetitive (Arps, Ostinatos)
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.5,
        weight: 0.1
    },

    // Rhythmic Lock: Absolute Grid
    rhythmicLock: {
        ...SLOW_ARCHETYPE.rhythmicLock,
        weight: 0.4 // Critical
    },

    // Narrative Arc: Build-Drop structure
    narrativeArc: {
        weight: 0.3
    },

    motivicRepetition: {
        ...SLOW_ARCHETYPE.motivicRepetition,
        target: 0.8, // Very High (Loops)
        tolerance: 0.1,
        weight: 0.2
    }
};
